const fetchFileList = async ({ dispatch, dispatchFunc, dispatchParams }) => {
  try {
    const responseObject = await dispatch(dispatchFunc(dispatchParams)).unwrap();

    return {
      data: responseObject.data,
      offset: responseObject.offset ?? null,
      hasMore: responseObject.hasMore ?? false,
    };
  } catch (error) {
    return { data: [], offset: null, hasMore: false };
  }
};

const getSearchKey = (activeTab, selectedFolder, propertyId, sort) => {
  let baseKey;

  if (selectedFolder?.oid) {
    baseKey = `folder:${selectedFolder.oid}`;
    // } else if (searchValue) {
    //   baseKey = `search:${searchValue}`;
  } else if (activeTab === 'property' && propertyId) {
    baseKey = `property:${propertyId}`;
  } else if (activeTab) {
    baseKey = `user:${activeTab}`;
  } else {
    baseKey = 'root';
  }

  return `${baseKey}::${sort}`;
};

export { fetchFileList, getSearchKey };
